import { HYPHENATED_PLACEHOLDER } from './constants';

export function toRoundedToEndOfDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(23, 59, 59, 999);
  return result;
}

function isValidDate(date: Date): boolean {
  return date instanceof Date && !isNaN(date.getTime());
}

export function localeStringLabel(date: string | number | Date): string {
  // TODO no debería darse la respuesta predeterminada de EMPTY_PLACEHOLDER. Cada componente que llame a esta función, debe poder controlar qué mostrar
  if (!date) return HYPHENATED_PLACEHOLDER;
  const attempt = new Date(date);
  return isValidDate(attempt) ? attempt.toLocaleDateString() : HYPHENATED_PLACEHOLDER;
}

export function localeStringWithTimeLabel(date: string | number | Date): string {
  if (!date) return;
  const attempt = new Date(date);
  if (!isValidDate(attempt)) return;
  return attempt.toLocaleString();
}

function getDate(date: string | Date): Date {
  return typeof date === 'string' ? new Date(date) : date;
}

export function isSameDay(date1: string | Date, date2: string | Date): boolean {
  const compareDate1 = getDate(date1);
  const compareDate2 = getDate(date2);
  return (
    compareDate1.getFullYear() === compareDate2.getFullYear() &&
    compareDate1.getMonth() === compareDate2.getMonth() &&
    compareDate1.getDate() === compareDate2.getDate()
  );
}

export function isBeforeDay(date1: string | Date, date2: string | Date): boolean {
  const compareDate1 = getDate(date1);
  const compareDate2 = getDate(date2);
  return (
    compareDate1.getFullYear() === compareDate2.getFullYear() &&
    compareDate1.getMonth() === compareDate2.getMonth() &&
    compareDate1.getDate() < compareDate2.getDate()
  );
}
